var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapitronbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9541 9.69763C27.1538 11.8973 34.2499 19.0096 34.2499 18.9942C36.5816 21.3251 36.5083 26.0331 34.1678 28.3707L27.7462 34.7959C25.1799 37.3622 20.5694 37.0645 18.7452 35.2402L27.5754 26.3975C28.2857 25.6562 28.6823 24.6692 28.6823 23.6425C28.6823 22.6157 28.2857 21.6287 27.5754 20.8874L18.6968 12.0066L21.0057 9.69763C21.5301 9.17636 22.2394 8.88379 22.9788 8.88379C23.7182 8.88379 24.4275 9.17636 24.9519 9.69763H24.9541Z",
    fill: "#2D3E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20094 11.5732C11.2078 9.56713 18.3479 2.44532 18.3296 2.44458C20.6605 0.113663 25.3685 0.186252 27.706 2.5267L34.1313 8.94901C36.6976 11.5153 36.3999 16.1258 34.5756 17.9501L25.557 8.94389C24.8925 8.27482 23.9943 7.88975 23.0515 7.86979C22.1088 7.84982 21.1951 8.19651 20.5029 8.83684L13.0071 16.3311L11.342 17.9963L9.20094 15.856C8.63534 15.287 8.31787 14.5173 8.31787 13.715C8.31787 12.9127 8.63534 12.143 9.20094 11.574V11.5732Z",
    fill: "#DB1C20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.914 27.4996C8.89767 25.4833 1.7854 18.3534 1.7854 18.371C-0.545517 16.0401 -0.472928 11.332 1.86752 8.99451L8.2891 2.56927C10.8554 0.00298798 15.4659 0.300686 17.2902 2.12495L8.33088 11.0967C6.93043 12.4971 7.13427 15.1558 8.45701 16.4785L17.3363 25.3593L15.1953 27.5004C14.6264 28.0661 13.8567 28.3837 13.0543 28.3837C12.252 28.3837 11.4822 28.0661 10.9133 27.5004L10.914 27.4996Z",
    fill: "#2D3E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7995 25.7402C24.7832 27.7565 17.6533 34.8688 17.6709 34.8688C15.34 37.1997 10.6319 37.1272 8.29442 34.7867L1.86918 28.3651C-0.697103 25.7988 -0.399421 21.1883 1.42411 19.3641L10.3958 28.3226C11.1326 29.0068 12.1072 29.3765 13.1124 29.353C14.1176 29.3294 15.0739 28.9145 15.7777 28.1965L24.6585 19.3179L26.7995 21.4589C27.3653 22.0278 27.6829 22.7975 27.6829 23.5999C27.6829 24.4023 27.3653 25.172 26.7995 25.7409V25.7402Z",
    fill: "#2D3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitronbank);
export default __webpack_public_path__ + "static/media/capitronbank.3e06eca0d6becfc467fb9e2dcbaf091d.svg";
export { ForwardRef as ReactComponent };